import React, { useEffect, useRef, useState } from "react";
import AsyncSelect from "react-select/async";

import { getStores } from "../../../MyApi/stores";
import { getProducts } from "../../../MyApi/product";
import SkeletonWrapper from "../skeletonWrapper";

const EnhancedSearchProduct = ({ setProductId ,value ,storeId =null ,isMulti}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const timeOutId = useRef(null);
  const [defaultStores, setDefaultStores] = useState([]);
    const [isLoading, setLoading] = useState(true);
console.log('value', value)

   useEffect(() => {
    if (!value || !defaultStores.length) {
      setSelectedOption(null);
      return;
    }

    

    setSelectedOption(value);
  }, [ defaultStores ,value]);



  useEffect(() => {
    const fetchDefaultStores = async () => {
       setLoading(true);
      try {
             
        const res = await getProducts({ store_id: storeId });
        setDefaultStores(res?.data?.products || []);
      } catch (err) {
        setDefaultStores([]);
      }finally{
       setLoading(false);
      }
    };

    fetchDefaultStores();   
  }, [storeId]);
  const handelSearch = (selectedOptions) => {
    if (!selectedOptions) {
      setProductId("")
      setSelectedOption(null);
      return;
    }
    setSelectedOption(selectedOptions);
    const productId = selectedOptions ? selectedOptions.id : "";
    const name = selectedOptions ? selectedOptions.name : "";
    if(isMulti){
       setProductId(selectedOptions)
    }else{
    setProductId(productId ,name);
    }
  

  };    
  const enhancedSearchProducts = (value) => {
    return new Promise((resolve) => {
      if (value.length >= 5) {
        clearTimeout(timeOutId.current);
        timeOutId.current = setTimeout(async () => {
          try {
            let res = await getProducts({ store_id: storeId }, { search: value });
            console.log('res', res)
            resolve(res.data.products || []);
          } catch (error) {
            resolve([]);
          }
        }, 500);
      } else {
        resolve([]);
      }
    });
  };
  return (
    <SkeletonWrapper isLoading={isLoading} >

    <AsyncSelect
      getOptionValue={(e) => e.id}   
      getOptionLabel={(e) => e.name}
      loadOptions={enhancedSearchProducts}
      value={selectedOption}
      onChange={handelSearch}
      defaultOptions={defaultStores}
      isLoading={isLoading}
      isDisabled={isLoading}
      placeholder="اختار المنتج"
      isClearable 
      isMulti={isMulti}
      />
      </SkeletonWrapper>
  );
};

export default EnhancedSearchProduct;
